import * as logger from "@/core/logger";

export const openUrl = (url: string, samePage?: boolean) => {
  try {
    window.open(url, `${samePage ? "_self" : "_blank"}`, "noopener,noreferrer"); //
  } catch (e) {
    logger.error("Error opening new window", { messageContext: { url }, error: e });
  }
};
